import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '@/containers/Full.vue';

// Views
import Login from '@/views/admin/Login.vue';
import Dashboard from '@/views/admin/Dashboard.vue';
import Acl from '@/views/admin/Acl.vue';
import Translator from '@/views/admin/Translator.vue';
import Languages from '@/views/admin/Languages.vue';
import SiteProps from '@/views/admin/SiteProps.vue';
import EmailTemplates from '@/views/admin/EmailTemplates.vue';
import UserCompanies from '@/views/admin/UserCompanies.vue';
import Users from '@/views/admin/Users.vue';
import Generator from '@/views/admin/Generator.vue';
import Modules from '@/views/Modules.vue';
import Register from '@/views/Register.vue';
import UserDashboard from '@/views/Dashboard.vue';
import IrDevices from '@/views/IrDevices.vue';
import IrCodes from '@/views/IrCodes.vue';
import KeypadCodes from '@/views/KeypadCodes.vue';
import Rules from '@/views/Rules.vue';
import RulesCategories from '@/views/RulesCategories.vue';
import ActionLog from '@/views/ActionLog.vue';
// GENERATORLASTITEM

Vue.use(Router);

export default new Router(
    {
    // mode: 'history',
    // linkActiveClass: 'open active',
    // scrollBehavior: () => ({ y: 0 }),
        routes: [
            {
                path: '/dashboard',
                name: 'DASHBOARD',
                component: Full,
                children: [
                    {
                        path: '',
                        name: 'DASHBOARD',
                        component: UserDashboard,
                    }],
            },
            {
                path: '/modules',
                name: 'MODULES',
                component: Full,
                children: [
                    {
                        path: '',
                        name: 'MODULES',
                        component: Modules,
                    },
                    {
                        path: 'keypadcodes/:moduleId',
                        name: 'KEYPADCODES',
                        component: KeypadCodes,
                    }],
            },
            {
                path: '/actionlog',
                name: 'ACTIONLOG',
                component: Full,
                children: [
                    {
                        path: '',
                        name: 'ACTIONLOG',
                        component: ActionLog,
                    }],
            },
            {
                path: '/rules',
                name: 'RULES',
                component: Full,
                children: [
                    {
                        path: '',
                        name: 'RULES',
                        component: RulesCategories,
                    },
                    {
                        path: ':ruleCategoryId/rules',
                        name: 'RULES',
                        component: Rules,
                    }],
            },
            {
                path: '/irdevices',
                name: 'IRDEVICES',
                component: Full,
                children: [
                    {
                        path: '',
                        name: 'IRDEVICES',
                        component: IrDevices,
                    },
                    {
                        path: ':irDeviceId',
                        name: 'IRCODES',
                        component: IrCodes,
                    }],
            },
            {
                path: '/system',
                name: 'SYSTEM',
                component: Full,
                children: [
                    {
                        path: 'acl',
                        name: 'ACL',
                        component: Acl,
                    },
                    {
                        path: 'translator',
                        name: 'TRANSLATOR',
                        component: Translator,
                    },
                    {
                        path: 'languages',
                        name: 'LANGUAGES',
                        component: Languages,
                    },
                    {
                        path: 'siteprops',
                        name: 'SITEPROPS',
                        component: SiteProps,
                    },
                    {
                        path: 'emailtemplates',
                        name: 'EMAILTEMPLATES',
                        component: EmailTemplates,
                    },
                    {
                        path: 'usercompanies',
                        name: 'USERCOMPANIES',
                        component: UserCompanies,
                    },
                    {
                        path: 'users',
                        name: 'USERS',
                        component: Users,
                    },
                    {
                        path: 'generator',
                        name: 'GENERATOR',
                        component: Generator,
                    },
                    // GENERATORINSERT
                ],
            },
            {
                path: '/',
                redirect: '/login',
            },
            {
                path: '/login',
                name: 'LOGIN',
                component: Login,
            },
            {
                path: '/register',
                name: 'REGISTER',
                component: Register,
            }],
    },
);
